import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { ActionType } from '../search.action';

export interface SelectUser {
    user?: User;
}

export const selectUser = createAction<ActionType, SelectUser>(
    ActionType.EVAL_SEARCH__SELECT_USER,
);
